/** A horizontal Flexbox */

import type { HTMLAttributes, Ref } from 'react'

export const HBox = ({ style, ref, ...props }: HTMLAttributes<HTMLDivElement> & { ref?: Ref<HTMLDivElement> }) => (
  <div
    ref={ref}
    style={{
      display: 'flex',
      flexDirection: 'row',
      ...style,
    }}
    {...props}
  />
)
